var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expand-collapse-container"},[_c('div',{staticClass:"content-container"},[_c('p',{ref:"content",staticClass:"content"},[_vm._v(_vm._s(_vm.content))])]),(_vm.showButton)?_c('div',{staticClass:"button-container"},[_c('div',{staticClass:"btn",on:{"click":_vm.handleStatusChange}},[_vm._v(_vm._s(_vm.butttonLabel))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }